var subdomainUri = function subdomainUri(_ref) {
  var altdomain = _ref.altdomain,
    domain = _ref.domain,
    subdomain = _ref.subdomain,
    tld = _ref.tld;
  if (subdomain !== 'www') {
    return "https://".concat(altdomain, ".").concat(subdomain, ".").concat(domain, ".").concat(tld);
  }
  return "https://".concat(altdomain, ".").concat(domain, ".").concat(tld);
};
export default subdomainUri;
export { subdomainUri };
//# sourceMappingURL=subDomainUri.js.map